<template>
  <div>
    <div class="container-login">
      <div class="wrap-all-login wx-scan-modal">
        <div class="left-tips-box">
          <div class="logo"><img :src="urlImg + logo" /></div>
          <div class="text">
            <p>科汇云，让技术转移与成果转化变得简单起来。</p>
            <p class="wx-left-hint">微信扫码登录</p>
          </div>
        </div>
        <div class="wx-scan-panel">
          <div class="wx-qr-box">
            <div id="wx_login_container" class="wx-qr-container"></div>
            <div class="wx-qr-overlay" v-if="wxStatus === 'scanned'">
              <i class="el-icon-loading"></i>
              <span>正在登录...</span>
            </div>
            <div class="wx-qr-overlay is-expired" v-else-if="wxStatus === 'expired'">
              <span>二维码已过期</span>
              <button type="button" class="wx-refresh-btn" @click="initWxLogin">点击刷新</button>
            </div>
          </div>
          <button type="button" class="wx-login-back" @click="goBack">
            <i class="el-icon-arrow-left"></i>
            返回手机号登录
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Logo, WxQrState, WxCheck } from '@/common/js/api';
import { urlImg } from '@/common/js/url';

const DEFAULT_CALLBACK_BASE = (
  process.env.VUE_APP_WECHAT_CALLBACK ||
  process.env.VUE_APP_API_BASE_URL ||
  'http://hout.kehui.cloud'
).replace(/\/+$/, '');

export default {
  name: 'WxLoginNei',
  data() {
    return {
      logo: '',
      urlImg: '',
      wxState: '',
      wxPollingTimer: null,
      wxStatus: 'waiting',
    };
  },
  created() {
    this.urlImg = urlImg();
    this.getLogo();

    const wxState = this.$route.query.wx_state;
    if (wxState) {
      this.wxState = wxState;
      this.$nextTick(() => {
        this.startWxPolling();
      });
      return;
    }

    const wxError = this.$route.query.wx_error;
    if (wxError) {
      this.$message.error(decodeURIComponent(wxError));
    }

    this.initWxLogin();
  },
  beforeDestroy() {
    this.stopWxPolling();
  },
  methods: {
    getLogo() {
      Logo({})
        .then((res) => {
          this.logo = res.data.logo;
        })
        .catch(() => {});
    },
    goBack() {
      this.$router.push({ path: '/login' });
    },
    initWxLogin() {
      this.wxStatus = 'waiting';
      this.stopWxPolling();
      WxQrState({})
        .then((res) => {
          if (res.code === 200) {
            this.wxState = res.data.state;
            this.$nextTick(() => {
              this.renderWxQrCode();
              this.startWxPolling();
            });
          } else {
            this.$message.error('获取微信登录二维码失败');
          }
        })
        .catch(() => {
          this.$message.error('获取微信登录二维码失败');
        });
    },
    renderWxQrCode() {
      const container = document.getElementById('wx_login_container');
      if (!container) return;
      container.innerHTML = '';
      const appid = process.env.VUE_APP_WECHAT_APPID || 'your_appid';
      const redirectUri = encodeURIComponent(
        DEFAULT_CALLBACK_BASE + '/api/login/wx_callback'
      );
      // eslint-disable-next-line no-undef
      if (typeof WxLogin !== 'undefined') {
        // eslint-disable-next-line no-undef
        new WxLogin({
          self_redirect: false,
          id: 'wx_login_container',
          appid: appid,
          scope: 'snsapi_login',
          redirect_uri: redirectUri,
          state: this.wxState,
          stylelite: 0,
          color_scheme: 'light',
          fast_login: 1,
        });
      } else {
        const wxUrl = `https://open.weixin.qq.com/connect/qrconnect?appid=${appid}&redirect_uri=${redirectUri}&response_type=code&scope=snsapi_login&state=${this.wxState}#wechat_redirect`;
        container.innerHTML = `<div style="text-align:center;padding:20px;"><a href="${wxUrl}" target="_blank" style="color:#4470f3;font-size:14px;">点击此处使用微信扫码登录</a></div>`;
      }
    },
    afterLoginSuccess(res) {
      localStorage.setItem('user', JSON.stringify(res.data.user));
      window.localStorage.setItem('token', res.data.access_token);
      const redirect = this.$route.query.redirect;
      if (redirect && typeof redirect === 'string') {
        this.$router.push(redirect);
      } else {
        this.$router.push({ path: '/home' });
      }
    },
    startWxPolling() {
      this.stopWxPolling();
      this.wxPollingTimer = setInterval(() => {
        if (!this.wxState) return;
        WxCheck({ state: this.wxState })
          .then((res) => {
            if (res.code === 200) {
              this.stopWxPolling();
              this.wxStatus = 'waiting';
              this.$message.success('登录成功');
              this.afterLoginSuccess(res);
            } else if (res.code === 201) {
              this.wxStatus = 'waiting';
            } else if (res.code === 400) {
              this.stopWxPolling();
              this.wxStatus = 'expired';
            }
          })
          .catch(() => {});
      }, 2000);
    },
    stopWxPolling() {
      if (this.wxPollingTimer) {
        clearInterval(this.wxPollingTimer);
        this.wxPollingTimer = null;
      }
    },
  },
};
</script>

<style scoped src="./login.css"></style>
<style scoped lang="less">
#app .nav-bar .nav-top,
.el-container {
  display: none !important;
}
.container-login::before {
  content: '';
  background-color: #000;
  opacity: 0.6;
  z-index: -1;
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
}
.container-login {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: url(../../../assets/img/home/bg.jpg) 0 0 no-repeat;
  background-size: cover;
  position: relative;
  z-index: 99;
}
</style>
